// extracted by mini-css-extract-plugin
export default {"wrapper":"fx-z","viewport":"gx-z","container":"hx-z","slide":"ix-z"};